// Promo-related filters

import { createKeywordFilter } from './factories';
import type { FilterRegistry } from './types';

export const promoFilters: FilterRegistry = {
	promoKeywords: {
		...createKeywordFilter({
			label: 'Keywords',
			placeholder: 'Search by name, headline, or coupon code...',
			objectTable: 'promo',
			listKeys: ['promo'],
			fulltextFields: ['name', 'headline', 'couponCode'],
		}),
		queryParamName: 'promoKeywords',
	},
};
